import { Deserializable } from '@models/deserializable';
import { alias, deserialize, primitive, serializable } from 'serializr';

export class PortConfig implements Deserializable {
  @serializable(alias('debugger_port', primitive()))
  debuggerPort: number;
  @serializable(alias('http_port', primitive()))
  httpPort: number;
  @serializable(alias('https_port', primitive()))
  httpsPort: number;
  @serializable(alias('debugger_https_port', primitive()))
  debuggerHttpsPort: number;
  @serializable(alias('drifter_server_port', primitive()))
  drifterServerPort: number;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(PortConfig, input));
  }
}
